<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="input-number-wrapp">
      <div class="flex items-center mb-2">
        <label :for="name">
          <span>
            <span class="opacity-50">{{ label }}</span>
            <span v-if="required" class="text-red text-lg leading-none">*</span>
          </span>
        </label>

        <span v-if="tooltip" class="tooltip top">
          <button type="button" class="tooltip-icon" aria-label="info">
            <svg class="w-[6px] h-2">
              <use xlink:href="#icon-question"></use>
            </svg>

            <i class="tooltip-arrow"></i>
          </button>

          <span class="tooltip-popup">
            {{ tooltip }}
          </span>
        </span>
      </div>

      <div class="relative h-16 md:h-[72px]">
        <input
          class="block h-full w-full
                text-base text-blue font-medium
                px-8 input-border
              focus-visible:border-blue !outline-none duration-200"
          type="text"
          :id="name"
          placeholder=" "
          autocomplete="off"
          :value="value"
          @input="inputChange"
        />
      </div>
    </div>
    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'CalculatorInputLabel',

  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    required: Boolean,
    tooltip: {
      type: String,
      default: '',
    },
    value: String,
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
  },
  methods: {
    inputChange(e) {
      this.$emit('input', e.target.value)
    },
  },
}
</script>
